import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PresentationProfessional from "@/components/PresentationProfessional";

const BACKEND_URL = "";

export default function SharedPresentation() {
  const { token } = useParams();
  const [preventivo, setPreventivo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPreventivo = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/presentazione/${token}`);
        if (!res.ok) throw new Error("Non trovato");
        const data = await res.json();
        setPreventivo(data);
      } catch {
        setError("Presentazione non trovata o link non valido.");
      } finally {
        setLoading(false);
      }
    };
    fetchPreventivo();
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-sky-100 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-500">Caricamento presentazione...</p>
        </div>
      </div>
    );
  }

  if (error || !preventivo) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-sky-100 flex items-center justify-center">
        <div className="text-center max-w-sm">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-red-500 text-2xl font-bold">!</span>
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">Link non valido</h2>
          <p className="text-slate-500 text-sm">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <PresentationProfessional
      preventivo={preventivo}
      onClose={() => window.close()}
      isPublicView={true}
    />
  );
}
